import { toast } from "react-toastify";
import {
  fetchUsageStatisticsSuccess,
  fetchUsageStatisticsFailure,
} from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { GET_USAGE_STATISTICS_API } from "../../constants/constants";
import { setSuccessMessage } from "../../toastMessage/action";

export const getUsageStatistics =
  (setLoading, customerId) => async (dispatch) => {
    setLoading(true);
    await determineBaseUrlAndPerformApiCall(
      `${GET_USAGE_STATISTICS_API}/${customerId}`,
      "GET"
    )
      .then((response) => {
        setLoading(false);
        if (!response.error) {
          dispatch(fetchUsageStatisticsSuccess(response || []));
        //   dispatch(setSuccessMessage(true));
        }
        if (response.error) {
          if (response.error.code === "NotFound") {
            dispatch(fetchUsageStatisticsSuccess([]));
          } else {
            dispatch(fetchUsageStatisticsFailure(response.error.message));
            toast.error(`${response.error.message}`);
          }
        }
      })
      .catch((errorResp) => {});
  };
